/**
 * BUSINESSES PAGE - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Dark tool mode.
 */

import React, { useState, useCallback } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Screen, Section, Button } from '../design/primitives';
import BusinessList from '../components/BusinessList';
import BusinessForm from '../components/forms/BusinessForm';

const BusinessesPage: React.FC = () => {
  const [isBusinessFormOpen, setIsBusinessFormOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleBusinessCreated = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  return (
    <Screen>
      <Section
        title="Businesses"
        action={
          <Button
            variant="primary"
            onClick={() => setIsBusinessFormOpen(true)}
            icon={<PlusIcon style={{ width: '16px', height: '16px' }} />}
          >
            New Business
          </Button>
        }
      >
        <BusinessList key={refreshKey} />
      </Section>

      <BusinessForm
        isOpen={isBusinessFormOpen}
        onClose={() => setIsBusinessFormOpen(false)}
        onBusinessCreated={handleBusinessCreated}
      />
    </Screen>
  );
};

export default BusinessesPage;
